import ControllerApp from "./ControllerApp";
import { decodeFrameParams } from '../../../utils/frameParams';

const hash = window.location.hash.substring(1);
const params = decodeFrameParams(hash);

new ControllerApp(params);
